import React from "react";
import { makeStyles } from "@material-ui/styles";
import "./ButtonGroup.scss";

const ButtonGroupComponent = (props) => {
  const { activeButton, handleButtonGroup } = props;
  const buttons = ["list", "queue"];
  const useStyles = makeStyles(() => ({
    activeButton: {
      background: "#17bae0",
      color: "#fff",
    },
  }));

  const classes = useStyles();
  return (
    <div className="status-wrapper">
      {buttons.map((name, ind) => (
        <button
          key={ind}
          name={name}
          className={`status-button  ${
            activeButton === name ? `${classes.activeButton}` : ""
          }`}
          onClick={() => handleButtonGroup(name)}
          style={{ textTransform: "capitalize" }}
        >
          {name}
        </button>
      ))}
    </div>
  );
};

export default ButtonGroupComponent;
